import React, { useState } from 'react'
import Dialog from "@material-ui/core/Dialog"
import DialogTitle from "@material-ui/core/DialogTitle"
import DialogContent from "@material-ui/core/DialogContent"
import { Grid, Typography } from '../../../node_modules/@material-ui/core/index'
import useStyles from "./styles"
import CloseIcon from "@material-ui/icons/Close"
import TextField from '@material-ui/core/TextField';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Button from '@material-ui/core/Button';


import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import { getStripeUserUsingId, updateStripeUserUsingId, createStripeUser } from '../../actions/billing'
import { useDispatch } from 'react-redux'
import { isEmpty, pick } from 'lodash'
import CircularProgress from '@material-ui/core/CircularProgress';
import Chip from '@material-ui/core/Chip';
import Alert from '@material-ui/lab/Alert';



const ManageStripeDialog = ({ open, closeModel }) => {
    const classes = useStyles()
    const dispatch = useDispatch()
    const [loading, setLoading] = useState(false)
    const [searchKeyWord, setSearchKeyWord] = useState("")

    const [addNewStripeUser, setAddNewStripeUser] = useState(false)
    const [errorMessage, setErrorMessage] = useState("")




    const [userStripeData, setUserStripeData] = useState({
        id: "",
        stripe_account_id: "",
        user_id: "",
        complete: 0
    })

    const { id, stripe_account_id, user_id, complete } = userStripeData

    const [userStripeDataForCreateOrUpdate, setUserStripeDataForCreateOrUpdate] = useState({
        id: "",
        stripe_account_id: "",
        user_id: "",
        complete: 0
    })



    const handleClose = () => {
        closeModel(false)
    }

    const handelSearch = async () => {
        if (!isEmpty(searchKeyWord)) {
            setLoading(true)
            try {
                const result = await dispatch(getStripeUserUsingId(searchKeyWord))
                if (result.found) {
                    setUserStripeData(result.data)
                }
                else {

                    setErrorMessage(result.message)
                    setUserStripeData({
                        id: "",
                        stripe_account_id: "",
                        user_id: "",
                        complete: 0
                    })
                    setTimeout(() => {
                        setErrorMessage(null)

                    }, 3000);
                }

                setLoading(false)

            } catch (error) {
                console.log("Error", error)
                setLoading(false)

            }
        }

    }


    const handelNewStripeUser = () => {
        setAddNewStripeUser(!addNewStripeUser)
        setUserStripeDataForCreateOrUpdate({
            id: "",
            stripe_account_id: "",
            user_id: "",
            complete: 0
        })
        setUserStripeData({
            id: "",
            stripe_account_id: "",
            user_id: "",
            complete: 0
        })
        setSearchKeyWord("")
    }


    const handelChange = (e) => {
        const { name, value, checked } = e.target;

        if (name === "complete") {
            const checkedValue = checked ? 1 : 0
            setUserStripeDataForCreateOrUpdate({ ...userStripeDataForCreateOrUpdate, [name]: checkedValue })
        }
        else {

            setUserStripeDataForCreateOrUpdate({ ...userStripeDataForCreateOrUpdate, [name]: value })
        }

    }


    const handelAddOrUpdate = async () => {
        if (addNewStripeUser) {

            try {
                setLoading(true)
                let result = await dispatch(createStripeUser(userStripeDataForCreateOrUpdate))
                if (result.inserted) {
                    setUserStripeDataForCreateOrUpdate({
                        id: "",
                        stripe_account_id: "",
                        user_id: "",
                        complete: 0
                    })

                }
                setLoading(false)

            } catch (error) {
                console.log("Error", error)
            }


        }
        else {
            setLoading(true)
            const dataForUpdate = pick(userStripeDataForCreateOrUpdate, ["stripe_account_id", "user_id", "complete"])
            try {
                let result = await dispatch(updateStripeUserUsingId(userStripeDataForCreateOrUpdate.id, dataForUpdate))
                if (result.updated) {
                    setUserStripeData(result.data)
                }
                setLoading(false)

            } catch (error) {
                console.log("Error", error)
                setLoading(false)

            }

        }
    }



    const handelEdit = () => {
        setUserStripeDataForCreateOrUpdate(userStripeData)
    }

    return (
        <Dialog
            className={classes.profileDialog}
            fullScreen={false}
            open={open}
            maxWidth="sm"

        >
            {
                loading && <div style={{ position: "absolute", background: "black", width: "100%", height: "100%", display: "flex", justifyContent: "center", alignItems: "center", opacity: "0.4", zIndex: "100" }}>
                    <CircularProgress
                        size={40}
                        thickness={4}
                        value={100}
                        style={{ color: "#E5E5E5" }}
                    />
                </div>
            }


            <DialogTitle disableTypography className={classes.dialogTitle}>
                <Typography variant="h6">Handle Stripe Users</Typography>
                <IconButton
                    className={classes.closeButton}
                    onClick={handleClose}
                    aria-label="Close"
                >
                    <CloseIcon classes={{ root: classes.closeIcon }} />
                </IconButton>
            </DialogTitle>

            <DialogContent style={{ overflow: "hidden" }}>


                <Grid item md={12}>
                    <FormControlLabel
                        control={<Checkbox color="primary" checked={addNewStripeUser} name="addNewStripeUser" onChange={handelNewStripeUser} />}
                        label="Add New Stripe User"
                    />
                </Grid>
                <Grid container spacing={5} style={{ marginTop: "5px", marginBottom: "10px" }}>


                    {
                        !addNewStripeUser &&
                        <>
                            <Grid item md={8}>
                                <TextField label="Search using stripe account id or user id" fullWidth value={searchKeyWord} onChange={(e) => setSearchKeyWord(e.target.value)} />
                            </Grid>
                            <Grid item md={4} style={{ display: "flex", justifyContent: "flex-end", alignItems: "flex-end" }}>
                                <Button variant="contained" color="primary" onClick={handelSearch}>
                                    Search
                                </Button>
                            </Grid>
                            {
                                errorMessage && <Grid item xs={12} style={{ zIndex: "5000" }}>

                                    <Alert variant="filled" severity="error" style={{ background: "#F44336" }}>
                                        {errorMessage}
                                    </Alert>
                                </Grid>
                            }

                            {
                                id && <TableContainer component={Paper}>
                                    <Table aria-label="simple table">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>User Id</TableCell>
                                                <TableCell>Stripe Account Id</TableCell>
                                                <TableCell>Is Completed</TableCell>
                                                <TableCell></TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            <TableCell>{user_id}</TableCell>
                                            <TableCell>{stripe_account_id}</TableCell>
                                            <TableCell>{<Chip label={complete == "1" ? "Yes" : "No"} size="medium" color="primary" />}</TableCell>
                                            <TableCell>
                                                <IconButton color="primary" aria-label="upload picture" component="span" onClick={handelEdit}>
                                                    <EditIcon />
                                                </IconButton>
                                                {/* <IconButton color="primary" aria-label="upload picture" component="span">
                                                    <DeleteIcon />
                                                </IconButton> */}
                                            </TableCell>
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            }
                        </>
                    }





                    <Grid item md={6} xs={12}>
                        <TextField label="User Id" variant="outlined" fullWidth required
                            name="user_id"
                            value={userStripeDataForCreateOrUpdate.user_id}
                            onChange={handelChange}

                        />
                    </Grid>
                    <Grid item md={6} xs={12}>

                        <TextField label="Stripe Account Id" variant="outlined" fullWidth required
                            name="stripe_account_id"
                            value={userStripeDataForCreateOrUpdate.stripe_account_id}
                            onChange={handelChange}
                        />

                    </Grid>
                    <Grid item md={6} xs={12}>

                        <FormControlLabel
                            control={<Checkbox color="primary" checked={userStripeDataForCreateOrUpdate.complete === 0 ? false : true} name="complete" />}
                            label="Is Completed"
                            onChange={handelChange}

                        />

                    </Grid>
                    <Grid item md={6} xs={12} style={{ display: "flex", justifyContent: "center" }}>
                        <Button variant="contained" color="primary" onClick={handelAddOrUpdate}>


                            {addNewStripeUser ? "Submit" : "Update"}
                        </Button>
                    </Grid>
                </Grid>


            </DialogContent>





        </Dialog >
    )
}

export default ManageStripeDialog